import { Outlet, Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '../stores/authStore'
import './Layout.css'

export default function Layout() {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { user, logout } = useAuthStore()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const toggleLanguage = () => {
    const newLang = i18n.language === 'he' ? 'en' : 'he'
    i18n.changeLanguage(newLang)
    document.documentElement.lang = newLang
    document.documentElement.dir = newLang === 'he' ? 'rtl' : 'ltr'
    localStorage.setItem('language', newLang)
  }

  if (!user) {
    navigate('/login')
    return null
  }

  const isAdmin = user.role === 'admin' || user.role === 'TenantAdmin'

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="nav-brand">Nexus</div>
        <div className="nav-links">
          {/* Core navigation — visible to all authenticated users */}
          <Link to="/">{t('common.dashboard')}</Link>
          <Link to="/drones">{t('common.drones')}</Link>
          <Link to="/missions">{t('common.missions')}</Link>
          {/* Settings — visible only to Admin */}
          {isAdmin && (
            <Link to="/settings">{t('common.settings')}</Link>
          )}
        </div>
        <div className="nav-actions">
          <button onClick={toggleLanguage}>
            {i18n.language === 'he' ? 'EN' : 'עב'}
          </button>
          <button onClick={handleLogout}>{t('common.logout')}</button>
        </div>
      </nav>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  )
}
